import React from 'react';
import {CreateDeliveryForm, DistributionMarketer, DistributionProduct} from '../models/distribution.model';
import DistributionFormFields from './DistributionFormFields';

interface EnhancedDeliveryFormFieldsProps {
  formData: CreateDeliveryForm;
  marketers: DistributionMarketer[];
  products: DistributionProduct[];
  selectedMarketer: DistributionMarketer | undefined;
  selectedProduct: DistributionProduct | undefined;
  onInputChange: (field: keyof CreateDeliveryForm, value: string) => void;
  onSearchMarketers?: (searchTerm: string) => void;
  onSearchProducts?: (searchTerm: string) => void;
  isLoadingMarketers?: boolean;
  isLoadingProducts?: boolean;
}

const EnhancedDeliveryFormFields: React.FC<EnhancedDeliveryFormFieldsProps> = ({
  formData,
  marketers,
  products,
  selectedMarketer,
  selectedProduct,
  onInputChange
}) => {
  return (
    <DistributionFormFields
      formData={formData}
      marketers={marketers}
      products={products}
      selectedMarketer={selectedMarketer}
      selectedProduct={selectedProduct}
      onInputChange={onInputChange}
    />
  );
};

export default EnhancedDeliveryFormFields;
